import { getLanguageIdFromLocalStorage, hasLocaleInLocalStorage } from "@tm/utils"
import { AppConfig } from "../data/loadConfiguration"
import { LoginMatch } from "../login/matchLoginUrl"
import { isLanguageAllowedByConfig } from "./utils"

export function getLanguageId(config: AppConfig, loginMatch?: LoginMatch | undefined) {
    // The language in the SSO url has top priority
    return loginMatch?.lang ?? tryRestoreLanguageId(config) ?? config.locale
}

function tryRestoreLanguageId(config: AppConfig): string | undefined {
    if (!hasLocaleInLocalStorage()) {
        return
    }
    const storedLanguageId = getLanguageIdFromLocalStorage()
    return storedLanguageId && isLanguageAllowedByConfig(storedLanguageId, config) ? storedLanguageId : undefined
}
